module.exports = __webpack_public_path__ + "static/bg_027_softness-1242900f05483d4ce1185e3934b3df88.webp";